import MeasureDetailPage from './MeasureDetailPage';

export default MeasureDetailPage;
